// removed by extract-text-webpack-plugin
module.exports = {"receipt-loyalty-info":"app-components-receipt-commons-LoyaltyInfo-__style___3KkfU","title":"app-components-receipt-commons-LoyaltyInfo-__style___3VEh4","loyalty-info-detail":"app-components-receipt-commons-LoyaltyInfo-__style___1sR16"};


//////////////////
// WEBPACK FOOTER
// ./app/components/receipt/commons/LoyaltyInfo/style.css
// module id = 1998
// module chunks = 0